import { render } from "./InvoiceItem.vue?vue&type=template&id=18abade8&scoped=true"
import script from "./InvoiceItem.vue?vue&type=script&lang=ts"
export * from "./InvoiceItem.vue?vue&type=script&lang=ts"

import "./InvoiceItem.vue?vue&type=style&index=0&id=18abade8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-18abade8"

export default script